
$(document).ready(function() {
    /* scrollable table */

    const privacyPage = document.querySelector('.privacy');

    function detectIsScrollable(){
    var $scrollable = $('.scrollable')
    var $innerDiv = $('.scrollable > div');

    if ($innerDiv.outerWidth() < $innerDiv.get(0).scrollWidth) {
        $scrollable.addClass('is-scrollable');
    } else {
        $scrollable.removeClass('is-scrollable');
    }
    }

    $(document).ready(function () {
    if (privacyPage) {
        detectIsScrollable();
    }
    });

    $(window).resize(function() {
    if (privacyPage) {
        detectIsScrollable();
    }
    });
});
